<profile-wrapper class="profile">
  <user-information></user-information>
  <div>
    <personal-information></personal-information>
    <div class="flex-col gap-4">
      <change-password></change-password>
      <user-subscription></user-subscription>
    </div>
  </div>
</profile-wrapper>
